/** Extrai UUID da rota pública `/p/:proposalId` (path relativo ou URL absoluta). */
export function extractPublicProposalId(link: string | null | undefined): string | null {
  if (!link?.trim()) return null
  const match = link.trim().match(/\/p\/([0-9a-f-]{36})(?:\/|$|\?)/i)
  return match?.[1] ?? null
}

export function publicProposalPreviewPath(proposalId: string, variant: 'v2' | 'v1' = 'v2'): string {
  return variant === 'v2' ? `/p/${proposalId}/v2` : `/p/${proposalId}`
}
